import ClueDetailNewPage from "@/pages/clueManage/clueDetail";
import {useParams} from "react-router-dom";

const ClueDetailNew = () => {
  const {id} = useParams()
  return <ClueDetailNewPage id={id} viewPhoneKey={'clueViewPhone'}/>
}

export default ClueDetailNew